// madone-washbasins-v1 : volet « Demande de devis » des fiches lavabo.
// Lit la configuration choisie sur la fiche, envoie les plans puis la demande au Worker lavabo
// (workers/washbasin-quote). Le panier n'est jamais touché.

const MAX_FILES = 5;
const MAX_FILE_BYTES = 10 * 1024 * 1024;
const MIN_MESSAGE_ALONE = 20;
const FILE_TYPES = /\.(pdf|jpe?g|png|webp|heic|heif)$/i;
const SIDE_LABELS = { both: 'Avant et deux côtés', left: 'Avant et côté gauche', right: 'Avant et côté droit', front: 'Avant uniquement' };
const TAP_LABELS = { yes: 'Un perçage', no: 'Sans perçage (robinet mural)' };
const ERRORS = {
  file_too_large: 'Un fichier dépasse 10 Mo.',
  unsupported_type: 'Un fichier n’est pas un PDF ou une image.',
  quota_exceeded: 'Trop de fichiers pour une demande.',
  rate_limited: 'Trop d’envois en peu de temps. Réessayez dans une minute.',
  attachment_missing: 'Un plan n’a pas été reçu. Retirez-le et ajoutez-le de nouveau.',
  'Invalid request_content': 'Cochez une option, joignez un plan ou décrivez votre projet.',
  'Invalid contact.email': 'Vérifiez votre adresse e-mail.',
  'Invalid contact.phone': 'Vérifiez votre numéro de téléphone.',
};
const FALLBACK_ERROR = 'L’envoi n’a pas abouti. Réessayez, ou écrivez-nous à contact@marbrerie-madone.fr.';

const newRequestId = () => (crypto.randomUUID ? crypto.randomUUID() : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`).toLowerCase();
const formatSize = (n) => (n >= 1048576 ? `${(n / 1048576).toFixed(1).replace('.', ',')} Mo` : `${Math.max(1, Math.round(n / 1024))} Ko`);

function init(root) {
  if (root.dataset.wqReady) return;
  root.dataset.wqReady = '1';
  const d = root.dataset;
  const data = { endpoint: d.endpoint.replace(/\/+$/, ''), uid: d.uid, product: { title: d.title, handle: d.handle, model: d.model, material: d.material, color: d.color } };
  const dialog = root.querySelector('dialog');
  const form = dialog.querySelector('form');
  const status = form.querySelector('[data-wq-status]');
  const submit = form.querySelector('[data-wq-submit]');
  const fileInput = form.querySelector('[data-wq-files]');
  const fileList = form.querySelector('[data-wq-file-list]');
  const length = form.elements.lengthMm;
  const width = form.elements.widthMm;
  const files = []; // { file, fileId }
  let requestId = newRequestId();
  let sending = false;

  // Le bouton est dans le bloc juste avant le volet (même section).
  const scope = root.closest('.shopify-section, section, main') || document;
  const configurator = document.querySelector(`[data-washbasin-configurator][data-uid="${CSS.escape(data.uid)}"]`);
  const openers = scope.querySelectorAll('[data-washbasin-quote-open]');

  const checked = (name) => configurator?.querySelector(`input[name="${name}-${CSS.escape(data.uid)}"]:checked`) || null;
  const cardTitle = (input) => input?.closest('label')?.querySelector('.washbasin-card__title')?.textContent.trim() || '';

  function readConfiguration() {
    const skirt = checked('skirt');
    const hasSkirt = skirt?.dataset.hasSkirt === 'true';
    const basinInput = checked('basin');
    return {
      finish: checked('finish')?.value || '',
      basin: basinInput ? cardTitle(basinInput) : '',
      edge: cardTitle(skirt),
      sides: hasSkirt ? checked('sides')?.value || '' : '',
      tapDrill: checked('tap')?.value || '',
      lengthMm: configurator?.querySelector('[data-length]')?.value || '',
      widthMm: configurator?.querySelector('[data-width]')?.value || '',
    };
  }

  function renderRecap() {
    const c = readConfiguration();
    const rows = [['Finition', c.finish], ['Vasque', c.basin], ['Bordure', c.edge], ['Retombée sur', SIDE_LABELS[c.sides]], ['Perçage', TAP_LABELS[c.tapDrill]]].filter(([, v]) => v);
    const recap = form.querySelector('[data-wq-recap]');
    recap.replaceChildren(...rows.flatMap(([k, v]) => {
      const dt = document.createElement('dt'); dt.textContent = k;
      const dd = document.createElement('dd'); dd.textContent = v;
      return [dt, dd];
    }));
    if (!length.dataset.edited) length.value = c.lengthMm;
    if (!width.dataset.edited) width.value = c.widthMm;
  }

  for (const input of [length, width]) input.addEventListener('input', () => { input.dataset.edited = '1'; });

  for (const opener of openers) {
    opener.addEventListener('click', (event) => {
      event.preventDefault();
      renderRecap();
      dialog.showModal();
      document.documentElement.classList.add('wq-lock');
    });
  }
  dialog.addEventListener('close', () => document.documentElement.classList.remove('wq-lock'));
  dialog.addEventListener('click', (event) => { if (event.target === dialog && !sending) dialog.close(); });
  dialog.addEventListener('cancel', (event) => { if (sending) event.preventDefault(); });
  for (const button of form.querySelectorAll('[data-wq-close]')) button.addEventListener('click', () => { if (!sending) dialog.close(); });

  // Options : la précision s'ouvre quand l'option est cochée.
  for (const box of form.querySelectorAll('input[name="option"]')) {
    box.addEventListener('change', () => {
      const note = box.closest('.wq-option').querySelector('.wq-option__note');
      note.hidden = !box.checked;
      if (box.checked) note.querySelector('input').focus();
    });
  }

  // Plans : contrôlés ici, envoyés au moment de la demande.
  function renderFiles() {
    fileList.replaceChildren(...files.map((entry, index) => {
      const li = document.createElement('li');
      const name = document.createElement('span'); name.className = 'wq-files__name'; name.textContent = entry.file.name;
      const size = document.createElement('span'); size.className = 'wq-files__size'; size.textContent = formatSize(entry.file.size);
      const remove = document.createElement('button'); remove.type = 'button'; remove.className = 'wq-files__remove'; remove.textContent = 'Retirer';
      remove.setAttribute('aria-label', `Retirer ${entry.file.name}`);
      remove.addEventListener('click', () => { if (!sending) { files.splice(index, 1); renderFiles(); } });
      li.append(name, size, remove);
      return li;
    }));
  }

  fileInput.addEventListener('change', () => {
    const problems = [];
    for (const file of fileInput.files) {
      if (files.length >= MAX_FILES) { problems.push(`5 fichiers au maximum.`); break; }
      if (!FILE_TYPES.test(file.name)) { problems.push(`${file.name} : PDF ou image seulement.`); continue; }
      if (file.size > MAX_FILE_BYTES) { problems.push(`${file.name} dépasse 10 Mo.`); continue; }
      if (file.size === 0) { problems.push(`${file.name} est vide.`); continue; }
      files.push({ file, fileId: null });
    }
    fileInput.value = '';
    renderFiles();
    setStatus(problems.join(' '), Boolean(problems.length));
  });

  function setStatus(text, isError = false) {
    status.textContent = text;
    status.classList.toggle('wq-status--error', isError);
  }

  async function uploadFile(entry) {
    if (entry.fileId) return entry.fileId;
    const type = entry.file.type || 'application/octet-stream';
    const url = `${data.endpoint}/uploads?requestId=${encodeURIComponent(requestId)}&name=${encodeURIComponent(entry.file.name)}`;
    const response = await fetch(url, { method: 'POST', headers: { 'Content-Type': type }, body: entry.file });
    const body = await response.json().catch(() => ({}));
    if (!response.ok || !body.fileId) throw Object.assign(new Error(body.error || 'upload'), { code: body.error, file: entry.file.name });
    entry.fileId = body.fileId;
    return body.fileId;
  }

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (sending) return;
    setStatus('');
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }
    const message = form.elements.message.value.trim();
    const options = [...form.querySelectorAll('input[name="option"]:checked')].map((box) => {
      const note = form.querySelector(`[data-note-for="${CSS.escape(box.value)}"]`)?.value.trim() || '';
      return note ? { code: box.value, note } : { code: box.value };
    });
    if (!options.length && !files.length && message.length < MIN_MESSAGE_ALONE) {
      setStatus(ERRORS['Invalid request_content'], true);
      return;
    }

    sending = true;
    submit.disabled = true;
    try {
      const attachments = [];
      for (const [index, entry] of files.entries()) {
        setStatus(`Envoi des plans (${index + 1} sur ${files.length})…`);
        attachments.push(await uploadFile(entry));
      }
      setStatus('Envoi de la demande…');
      const c = readConfiguration();
      const num = (input) => (input.value === '' ? null : Number(input.value));
      const payload = {
        type: 'washbasin_quote_request',
        requestId,
        sourceUrl: window.location.href,
        product: data.product,
        configuration: { finish: c.finish, basin: c.basin, edge: c.edge, sides: c.sides, tapDrill: c.tapDrill, lengthMm: num(length), widthMm: num(width) },
        options,
        attachments,
        contact: {
          name: form.elements.name.value.trim(),
          email: form.elements.email.value.trim(),
          phone: form.elements.phone.value.trim(),
          address1: form.elements.address1.value.trim(),
          postalCode: form.elements.postalCode.value.trim(),
          city: form.elements.city.value.trim(),
          message,
          consent: form.elements.consent.checked,
        },
      };
      const response = await fetch(`${data.endpoint}/`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
      const body = await response.json().catch(() => ({}));
      if (!response.ok || !body.ok) throw Object.assign(new Error(body.error || 'quote'), { code: body.error });
      showDone();
    } catch (error) {
      setStatus(ERRORS[error.code] ? `${error.file ? `${error.file} : ` : ''}${ERRORS[error.code]}` : FALLBACK_ERROR, true);
    } finally {
      sending = false;
      submit.disabled = false;
    }
  });

  function showDone() {
    form.querySelector('[data-wq-body]').hidden = true;
    form.querySelector('[data-wq-foot]').hidden = true;
    const done = form.querySelector('[data-wq-done]');
    done.hidden = false;
    done.focus();
    // Une nouvelle ouverture repart d'une demande vierge.
    dialog.addEventListener('close', () => {
      form.reset();
      files.splice(0); renderFiles();
      for (const note of form.querySelectorAll('.wq-option__note')) note.hidden = true;
      delete length.dataset.edited; delete width.dataset.edited;
      requestId = newRequestId();
      form.querySelector('[data-wq-body]').hidden = false;
      form.querySelector('[data-wq-foot]').hidden = false;
      done.hidden = true;
      setStatus('');
    }, { once: true });
  }
}

const boot = () => document.querySelectorAll('[data-washbasin-quote]').forEach(init);
boot();
document.addEventListener('shopify:section:load', boot);
